/**
 * Serviço de consolidação de alternativas
 */
import { SIMPLE_CARD } from 'src/sections/GroupCards/cardTypes';
import { analyzePrivClient } from '../api';

const endpoints = {
  [SIMPLE_CARD]: {
    create: (clientId, surveyId, analyzeId) =>
      `pesquisas/${surveyId}/clientes/${clientId}/perguntas/${analyzeId}/consolidacoes/configuracoes`,
    update: (clientId, surveyId, analyzeId, identifiers = '') =>
      `pesquisas/${surveyId}/clientes/${clientId}/perguntas/${analyzeId}/consolidacoes/configuracoes`,
    delete: (clientId, surveyId, analyzeId, identifiers) =>
      `pesquisas/${surveyId}/clientes/${clientId}/perguntas/${analyzeId}/consolidacoes/configuracoes/${identifiers}`,
  },
};

class ConsolidationService {
  constructor() {}

  createConsolidations(clientId, surveyId, analyzeId, consolidations) {
    const endpoint = endpoints[SIMPLE_CARD].create(
      clientId,
      surveyId,
      analyzeId
    );
    const resultPromise = analyzePrivClient.post(endpoint, consolidations);

    return resultPromise;
  }

  updateConsolidations(clientId, surveyId, analyzeId, consolidations) {
    const endpoint = endpoints[SIMPLE_CARD].update(
      clientId,
      surveyId,
      analyzeId,
    );
    const resultPromise = analyzePrivClient.put(endpoint, consolidations);
    return resultPromise;
  }

  deleteConsolidations(clientId, surveyId, analyzeId, identifiers) {
    const endpoint = endpoints[SIMPLE_CARD].delete(
      clientId,
      surveyId,
      analyzeId,
      identifiers
    );
    const resultPromise = analyzePrivClient.delete(endpoint);
    return resultPromise;
  }
}

export const consolidationService = new ConsolidationService();
